module.exports = __webpack_public_path__ + "img/stick_divers_rails_train.22a82fdd.svg";